"use strict";

angular.module('app.modals.selectIcon', [])

    .controller('selectIconModalCtrl',['$scope', '$rootScope', '$location', 'f_Info','ImageName','close',
        function ($scope, $rootScope, $location, f_Info,ImageName,close) {
            $scope.rootScope = $rootScope;
            $scope.selectedItem = undefined;
            $scope.currentPage = 0;
            $scope.pageSize = 30;
            $scope.selectedGroup = {};
            // Parse Number of Pages

            $scope.init = function () {
                var found = false;

                if (ImageName) {

                    $scope.ImageName = ImageName;

                    for (var i = 0; i < $scope.icons.length; i++) {
                        for (var j = 0; j < $scope.icons[i].Icons.length; j++) {
                            if ($scope.ImageName == $scope.icons[i].Icons[j].Class) {
                                $scope.selectedGroup = $scope.icons[i];
                                $scope.selectedItem = $scope.icons[i].Icons[j];
                                $scope.currentPage = Math.floor(j / $scope.pageSize);
                                found = true;
                                return;
                            }
                        }
                    }
                }
                if (!found) {
                    $scope.currentPage = 0;
                    $scope.selectedGroup = $scope.icons[1];
                }


            }

            $rootScope.$watch('icons', function () {
                $scope.init();
            })

            $scope.numberOfPages = function () {
                return Math.ceil($scope.selectedGroup.Icons.length / $scope.pageSize);
            }



            // Close Widget
            $scope.close = function (save) {

                close();
            }
            $scope.save = function(){

                close( $scope.selectedItem.Class );
            }
            // Select a icon
            $scope.selectIcon = function (m) {

                $scope.selectedItem = m;

            }
            $scope.setIconGroup = function (g) {
                $scope.selectedGroup = g;
                $scope.currentPage = 0;
            }




            // Icon CSS-Classes
            $scope.icons = _ICONWIDGETICONS;

        }])

    .factory('selectIconModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (ImageName) {

            return ModalService.showModal({
                templateUrl: "views/modals/selectIcon.html",
                controller: 'selectIconModalCtrl',
                inputs: {
                    ImageName: ImageName
                }
            });


        }
    }]);
